import React from 'react';
import EditSwitch from './EditSwitch';

interface CustomSwitchProps {
  label: string;
  checked: boolean;
  onChange: (v: boolean) => void;
  className?: string;
}

const CustomSwitch: React.FC<CustomSwitchProps> = React.memo(({ label, checked, onChange, className }) => (
  <div className={className || 'form-group'}>
    <label className="margin-bottom-3">{label}</label>
    <EditSwitch checked={checked} onChange={onChange} />
  </div>
));

export default CustomSwitch; 